<script lang="ts">
    export let link = '';
    export let campaignId = '';
    export let companyId = '';

    const utmParams = `?utm_source=badge&utm_medium=perspective-badge&utm_campaign=${campaignId}&utm_term=${companyId}`;
    const badgeLink = `${link || 'https://perspective.co'}${utmParams}`;
</script>

<div class="fun-relative">
    <a
        class="fun-fixed fun-bottom-3 fun-right-3 fun-z-50 fun-box-border fun-flex fun-h-[46px] fun-w-40 fun-cursor-pointer fun-items-center fun-rounded-md fun-bg-[#343435] fun-px-[13px] fun-py-[11px] fun-font-ui fun-no-underline"
        href={badgeLink}
        target="_blank"
        rel="noopener noreferrer"
    >
        <div class="fun-flex fun-content-start fun-items-center">
            <img
                class="fun-w-[25px]"
                src="https://perspective.imgix.net/assets/app/logo/64x64.png"
                alt="perspective logo"
            />
        </div>
        <div class="fun-flex fun-flex-grow fun-flex-col fun-items-center">
            <div class="fun-text-xs fun-text-white">Try for free!</div>
            <div class="fun-flex fun-items-center">
                <div class="fun-text-[7px]">
                    <span role="img" aria-label="lightning bolt"> ⚡ </span>
                    ️
                </div>
                <div class="fun-text-[8px] fun-text-gray-400">by perspective</div>
            </div>
        </div>
        <div class="fun-flex fun-items-center fun-justify-end">
            <svg
                width="8px"
                height="12px"
                viewBox="0 0 8 12"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
            >
                <defs />
                <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <polygon
                        id="Shape"
                        fill="#FFFFFF"
                        points="1.41 0 0 1.41 4.58 6 0 10.59 1.41 12 7.41 6"
                    />
                </g>
            </svg>
        </div>
    </a>
</div>
